import { APP_CONFIG } from '../config/AppConfig';
import { AUTH_V1_API_BASE_URL, CMS_API_BASE_URL } from '../config/backendEndpoints';
import { createApiClient } from './client';
import { createSession } from './session';

export * from './client';
export * from './errors';
export * from './image';
export * from './link';
export * from './retry';
export * from './middleware/auth';
export * from './middleware/context';
export * from './session';

/** The browser session: `/v1/auth/*` on the auth host, cookie mode. */
export const session = createSession({
  baseUrl: AUTH_V1_API_BASE_URL,
  platform: 'web',
  appVersion: APP_CONFIG.APP_VERSION,
});

/** The app-wide client: Bearer from the session, refresh-on-401 through it. */
export const api = createApiClient({
  baseUrl: CMS_API_BASE_URL || '',
  platform: 'web',
  appVersion: APP_CONFIG.APP_VERSION,
  getAccessToken: session.getAccessToken,
  refreshAccessToken: session.refreshForRetry,
  onSessionEnded: session.endLocally,
});
